(() => {
  function replaceLinksInGdprCheckbox() {
    if (!window.jQuery) {
      // if init is triggered before jQuery is loaded, retry later
      return setTimeout(replaceLinksInGdprCheckbox, 100);
    } else if (document.readyState !== 'complete') {
      // if jQuery is loaded but document not ready, attach to event
      return $(replaceLinksInGdprCheckbox);
    }

    $('form .gdpr-checkbox').not('.customized').each(function (i, e) {
      var dynamicGdprLink = $(this).parents('.form-element-wrapper').data('gdpr-link');
      if (isset(dynamicGdprLink, 'string')) {
        $(this).children('.gdpr-appendix').children('a').attr('href', dynamicGdprLink);
        $(this).addClass('customized');
      }
    });
  }

  // Trigger the function on each ajax form load
  window.addEventListener('ajax_form_load_success', replaceLinksInGdprCheckbox);
  
  // Also trigger upon page load to work on "normal" forms
  $(replaceLinksInGdprCheckbox);
})();
